/**
*
*/
<template>
    <div>
        <van-nav-bar
                title="租客"
                left-arrow
                :fixed="true"
                :placeholder="true"
                @click-left="onClickLeft"
                @click-right="onClickRight"
        >
<!--            <icon name="chat-o" slot="right" size="20px" info="1" color="#ffffff"></icon>-->
        </van-nav-bar>
        <div>
            <div>
                <cell :title="room.name" :label="room.detail" is-link @click="goToEdit" />
              <div class="item-box">
                <span>水表编号:</span><span>{{room.waterMeterSn}}</span>
                <div class="flow-right"><span>电表编号:</span><span>{{room.electricityMeterSn}}</span></div>
              </div>
                <van-panel v-if="room.remark" title="备注">
                    <div v-html="room.remark"></div>
                </van-panel>
            </div>
            <div class="btn-row">
                <Button icon="star-o" type="primary" size="large" @click="goToTenantAdd">添加租客</Button>
                <Button icon="notes-o" type="info" size="large" @click="goToMeterRecords">抄表记录</Button>
            </div>
            <cell-group>

<!--                <template v-for="{vo, index} in houses">-->
<!--                    {{vo.name}}{{vo.index}}-->
                    <cell  v-for="(vo, index) in tenants" :title="formatTitle(vo)" :label="formatDetail(vo)"
                           :value="formatStatus(vo)" is-link :key="'tenant_' + index" @click="goToRental(vo)" />
<!--                </template>-->

            </cell-group>
        </div>
    </div>
</template>

<script>
    import { Grid, GridItem, Icon, Button, Cell, CellGroup } from 'vant';
    import {copyValue, DateFormat} from "@/common/utils";
    import messageBox from "@/common/messageBox";

    // import { NavBar, Toast } from 'vant';
    // import HelloWorld from '@/components/HelloWorld.vue'

    export default {
        name: "index",
        components:{
            // eslint-disable-next-line vue/no-unused-components
            // NavBar,
            Button,
            Cell,
            CellGroup,
            Grid,
            GridItem,
            Icon
        },
        data() {
            return {
                room: {
                    id: "",
                    name: "101",
                    detail: "1房1厅1卫 500.00元/月",
                    remark: '',
                    waterMeterSn: '',
                    electricityMeterSn: '',
                },
                tenants: [
            // rentedTime: null
            // outTime: null
            // name: "杨昌伟"
            // is_rented: 1
            // id: 2
                    // {
                    //     id:"1",
                    //     name: "王老五",
                    //     detail: "",
                    //     status: "",
                    // },
                ]
            }
        },
        created() {
            copyValue(this.room, this.$route.query)
            this.getRents()
            this.getRoomDetail()
        },
        mounted() {
            // this.login();
        },
        // activated() {
        //     console.log("activated useCache: ", this.$route.meta.useCache)
        //     if(!this.$route.meta.useCache){
        //         copyValue(this.room, this.$route.query)
        //         this.getRents()
        //         this.getRoomDetail()
        //     }
        // },
        methods: {
            formatTitle(item){
                let title = '';
                if(item.name){
                    title += item.name;
                }
                if(item.tel){
                    title += '(' + item.tel + ')';
                }
                if(!title){
                    title = '未知租客';
                }
                return title;
            },
            formatStatus(item){
                // 租凭状态：0已退租，1租凭中
                switch (item.isRented) {
                    case 0:
                        return '已退租';
                    case 1:
                        return '租凭中';
                    case 2:
                        return '预订';
                    case 3:
                        return '过节未回';
                    default:
                        return item.isRented;
                }
            },
            formatDetail(item){
                let msg = '';
                if(item.rentedTime){
                    msg += '入住日期：' + DateFormat(new Date(item.rentedTime), 'yyyy-MM-dd')
                }
                if(item.outTime){
                    msg += ' - ' + DateFormat(new Date(item.outTime), 'yyyy-MM-dd')
                }
                return msg;
            },
            getRoomDetail(){
                this.$get('/rooms/detail', {id: this.room.id}).then(({data})=>{
                    copyValue(this.room, data);
                    console.log(data)
                })
            },
            getRents(){
                this.$get('/rent/list', {roomId: this.room.id}).then(({data})=>{
                    this.tenants = data
                })
            },
            onClickLeft() {
                this.$goBack();
            },
            onClickRight() {
                this.$toast('按钮');
                // Toast('按钮');
            },
            goToRental(item){
                this.$goPage('/rental', {customId: item.customId, rentId: item.id})
            },
            goToTenantAdd(){
                for (let rent of this.tenants){
                    if(rent.isRented !== 0){
                        messageBox.showToastError('已有租客，请先退租！')
                        return;
                    }
                }
                // this.$router.push({path:'/tenantAdd'});
                this.$goPage('/tenantAdd', this.room);
            },
            goToEdit() {
                this.$goPage('/rooms/edit', {id: this.room.id});
            },
            goToMeterRecords() {
                this.$goPage('/meterRecords', {roomId: this.room.id});
            }
        }
    }
</script>

<style scoped lang="less">
    .item-text{
        font-size: 12px;
        color: #8f8f94;
        margin-top: 8px;
    }
    .van-nav-bar{
        background-color: #409EFF;
        .van-nav-bar__title{
            color: #ffffff;
        }
    }
    .item-box{
      padding: 10px 16px;
      font-size: 12px;
      color: #8f8f94;
      .flow-right {
        display: inline-block;
        position: absolute;
        width: 45%;
        right: 10px;
      }
    }
    .btn-row{
      display: flex;
      padding: 10px 16px;
      .van-button{
        flex: 1;
      }
      .van-button:first-child{
        margin-right: 10px;
      }
    }
</style>
